/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wf_topn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show top N`)
};

const es_wf_topn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar top N`)
};

const de_wf_topn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top N anzeigen`)
};

const nl_wf_topn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top N weergeven`)
};

const fr_wf_topn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher les N premiers`)
};

const it_wf_topn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra i migliori N`)
};

const pt_br2_wf_topn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar top N`)
};

const pt_wf_topn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar top N`)
};

const ja_wf_topn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上位Nを表示`)
};

const zh_wf_topn = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示前 N 个`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wf_topn = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wf_topn(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wf_topn", locale)
	if (locale === "en") return en_wf_topn(inputs)
	if (locale === "es") return es_wf_topn(inputs)
	if (locale === "de") return de_wf_topn(inputs)
	if (locale === "nl") return nl_wf_topn(inputs)
	if (locale === "fr") return fr_wf_topn(inputs)
	if (locale === "it") return it_wf_topn(inputs)
	if (locale === "pt-BR") return pt_br2_wf_topn(inputs)
	if (locale === "pt") return pt_wf_topn(inputs)
	if (locale === "ja") return ja_wf_topn(inputs)
	return zh_wf_topn(inputs)
};